<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 19" fill="none">
	<path d="M16.5 2L8.25 10.25" stroke="#6C757D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
	<path d="M16.5 2L11.25 17L8.25 10.25L1.5 7.25L16.5 2Z" stroke="#6C757D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>